import { Fragment } from 'react';
import { Dash, EnterpriseLink } from '@mews-commander/ui';
import { Stack, Typography } from '@optimus-web/core';
import { Target, UnicodeEntity } from '@mews/enums';
import { Reservations } from '@mews-commander/data-access';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

export const PaymentDetailsSidePanelReservations = ({ reservations }: { reservations: Reservations }) => {
    if (!reservations || reservations.totalCount === 0) {
        return <Dash />;
    }

    if (reservations.totalCount === reservations.items.length) {
        return (
            <Stack wrap>
                {reservations.items.map((item, index, { length }) => (
                    <Fragment key={item.id}>
                        <Typography textStyle="bodyMedium" as="div">
                            {item.id ? (
                                <EnterpriseLink
                                    to="Reservation/Detail/$reservationId"
                                    params={{ reservationId: item.id || '' }}
                                    target={Target.Blank}
                                    data-test-id="payout-payment-detail-reservation"
                                    inherit
                                >
                                    {item.reportingIdentifier || <Dash />}
                                </EnterpriseLink>
                            ) : (
                                item.reportingIdentifier || <Dash />
                            )}
                        </Typography>
                        {index < length - 1 && UnicodeEntity.Comma + UnicodeEntity.NoBreakSpace}
                    </Fragment>
                ))}
            </Stack>
        );
    }

    return (
        <Typography textStyle="bodyMedium" as="div">
            <LocalizedText
                textKey={TextKey.PayoutDetailReservationsInBill}
                substitutes={{ reservationsTotalCount: reservations.totalCount }}
            />
        </Typography>
    );
};
